export const whatsappText = (text) => {
  const url = `https://api.whatsapp.com/send?phone=971567723422&text=${encodeURI(
    text
  )}`;
  window.open(url, "_blank");
};
